<template>
  <div>
    <!-- todo - https://stackoverflow.com/questions/50392918/vuetify-how-to-preselect-active-tab
     -->
    <v-tabs v-model="activetab" align-with-title class="mt-n2 pb-0 tab-headers-details">
      <v-tab v-for="tab of tabs" class="common-font-size"
      :key="tab.id" @click="WarnUser(tab.to)" :id="`mtgTransSequenceTab${tab.id}`"
        :class="`mtg-trans-sequence-tab-${tab.id}`">
        <v-badge
          v-if="tab.showAuditBadge"
          :value="unapprovedAuditBadgeCount > 0"
          :content="unapprovedAuditBadgeCount"
          color="red"
          offset-x="-2"
          offset-y="8"
        >
          <span>{{ tab.caption }}</span>
        </v-badge>
        <span v-else>{{ tab.caption }}</span>
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import CommonDropDownsMixins from '../components/tax/common-utils/CommonDropDowns.mixin.vue';
import '../assets/style.css';

export default {
  name: 'taxPayments',
  mixins: [CommonDropDownsMixins],
  components: {
  },
  created() {
    this.getPathName();
    this.loadDropDownList();
    this.loadUnapprovedAuditCount();
  },
  updated() {
    this.getPathName();
  },
  data: () => ({
    dialog: false,
    path: '',
    activetab: 0,
    tabs: [
      { id: 1, to: { path: '/tax/payments/dashboard' }, caption: 'Payments' },
      { id: 2, to: { path: '/tax/payments/reports' }, caption: 'Reports' },
      { id: 3, to: { path: '/tax/payments/utils/checkreconciliation' }, caption: 'Utils' },
      { id: 4, to: { path: '/tax/payments/CcPayments' }, caption: 'CC Payments' },
      {
        id: 5, to: { path: '/tax/payments/audit/list' }, caption: 'Auditing', showAuditBadge: true,
      },
      // { id: 6, to: { path: '/tax/payments/largePayments' }, caption: 'Large Payments' },
    ],
  }),
  computed: {
    ...mapGetters('tax/taxPayment', ['unapprovedAuditBadgeCount']),
  },
  methods: {
    ...mapActions('tax/taxPayment', ['loadUnapprovedAuditCount']),
    loadDropDownList() {
      this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
      this.loadFiscalYearList({ postProcessTrans: this.postProccessTaxYearData });
      this.loadTaxDistrict({
        criteria: {
          sortBy: [{
            column: 'districtCode',
            direction: 'asc',
          }],
        },
        baseCrudKey: 'sharedTaxDistrict',
      });
      this.loadTaxFeeMasterTypes({
        criteria: { sortBy: [{ column: 'feeNumber', direction: 'asc' }] },
        postProcessTrans: this.postProccessTaxFeeData,
        baseCrudKey: 'sharedTaxFeeMaster',
      });
      this.loadCommentTypes({
        criteria: { sortBy: [{ column: 'commentCode', direction: 'asc' }] },
        postProcessTrans: this.postProccessCommentsCategoryData,
        baseCrudKey: 'sharedTaxComments',
      });
    },
    getPathName() {
      const curPath = this.$route.path;
      const ftr = this.tabs.filter((ft) => ft.to.path === curPath);
      if (ftr.length) this.activetab = ftr[0].id - 1;
      else if (curPath.includes('utils')) this.activetab = 2;
      else if (curPath.includes('audit')) this.activetab = 4;
      else this.activetab = 0;
    },
    WarnUser(path) {
      this.path = path;
      const currentpath = this.$router.currentRoute.path;
      if (path.path !== currentpath) {
        this.$router.push(path);
      }
    },
  },

};
</script>
